import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import ProTag from '@alltrails/shared/components/ProTag';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type Props = {
  children: ReactNode;
  className?: string;
  hasDividerBars?: boolean;
  shouldTruncate?: boolean;
  tabIndex: number;
  title: string;
  isPro?: boolean;
};

const ExpandableFilterPanel = ({ children, className, hasDividerBars = false, shouldTruncate = false, tabIndex, title, isPro = false }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const getShowMoreContent = () => (
    <div aria-pressed={isExpanded} tabIndex={tabIndex} role="button" onKeyPress={toggleExpanded} onClick={toggleExpanded} className={styles.expand}>
      {isExpanded ? StringConstantsMixin.strings.SHOW_LESS : StringConstantsMixin.strings.SHOW_MORE}
    </div>
  );

  const truncate = !isExpanded && shouldTruncate;

  return (
    <div className={classNames(styles.container, { [styles.dividerBars]: hasDividerBars }, className)}>
      {title && (
        <div className={styles.titleContainer}>
          {isPro ? <ProTag className={styles.proTag} /> : null}
          <div className={styles.title}>{title}</div>
        </div>
      )}
      <div className={classNames(styles.body, { [styles.truncate]: truncate })}>
        <span>{children}</span>
      </div>
      {shouldTruncate ? getShowMoreContent() : ''}
    </div>
  );
};

export default ExpandableFilterPanel;
